import React from "react";
import { Modal } from "react-bootstrap";
import { StyledModal } from "../doctor-console/StyledComponents";
const EditAppointment = ({
  openEditModal,
  handleCloseEditModal,
  editHandleSubmit,
  editAppointmentSubmit,
  editRegister,
  editErrors,
  roleType,
  facilityDoctorList,
}) => {
  return (
    <StyledModal
      // style={{ zIndex: 9997 }}
      open={openEditModal}
      handleClose={handleCloseEditModal}
      // centered
      // backdrop="static"
      // className="appointment-modal"
      // size="lg"
      // responsive
      title="Edit Appointment"
    >
      {/* <Modal.Header closeButton>
        <Modal.Title>Edit Appointment</Modal.Title>
      </Modal.Header> */}

      {/* <Modal.Body style={{ overflowY: "auto", padding: "1.5rem" }}> */}
      <div style={{ padding: "12px" }}>
        <form
          className="contact-panel__form"
          onSubmit={editHandleSubmit(editAppointmentSubmit)}
        >
          <div className="row g-3">
            {roleType !== "doctor" && (
              <div className="col-12">
                <label>Select a doctor</label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <select
                    className="form-control"
                    name="doctor_id"
                    {...editRegister("doctor_id")}
                  >
                    <option value="" disabled>
                      Select Doctor
                    </option>
                    {facilityDoctorList.map((doctor) => (
                      <option key={doctor.doctor_id} value={doctor.doctor_id}>
                        {doctor.name}
                      </option>
                    ))}
                  </select>
                  {editErrors.doctor_id && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {editErrors.doctor_id.message}
                    </p>
                  )}
                </div>
              </div>
            )}

            <div className="col-12 col-sm-6 col-md-6 col-lg-6">
              <label> Select appointment start time</label>
              <div className="form-group">
                <input
                  type="datetime-local"
                  className="form-control"
                  placeholder="Enter Appointment Start Time"
                  name="appointment_start_time"
                  style={{
                    WebkitAppearance: "none",
                    MozAppearance: "textfield",
                    appearance: "none",
                    min: new Date().toISOString().slice(0, 16),
                  }}
                  {...editRegister("appointment_start_time", {
                    required: "Appointment Start Time is required.",
                  })}
                />
              </div>
            </div>

            <div className="col-12 col-sm-6 col-md-6 col-lg-6">
              <label> Select appointment end time</label>
              <div className="form-group">
                <input
                  type="datetime-local"
                  className="form-control"
                  placeholder="Enter Appointment End Time"
                  name="appointment_end_time"
                  style={{
                    WebkitAppearance: "none",
                    MozAppearance: "textfield",
                    appearance: "none",
                    min: new Date().toISOString().slice(0, 16),
                  }}
                  {...editRegister("appointment_end_time", {
                    required: "Appointment End Time is required.",
                  })}
                />
              </div>
            </div>

            <div className="col-12">
              <button
                type="submit"
                className="btn btn__secondary btn__rounded btn__block mt-6 w-100"
              >
                Edit appointment
              </button>
            </div>
          </div>
        </form>
      </div>
      {/* </Modal.Body> */}
    </StyledModal>
  );
};

export default EditAppointment;
